const lastRecordStyle = (index, intItemReturn) => {
  const indxLenght = index + 1
  if (intItemReturn === indxLenght) {
    return {
      border: '1px solid #E0E0E0',
      width: '100%',
      borderRadius: '0 0 6px 6px',
      borderTop: '0px',
    }
  }
  return {
    border: '#E0E0E0 solid 1px',
    width: '100%',
    borderTop: '0px',
  }
}

export default lastRecordStyle
